import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=21ff6fc8&scoped=true"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"
import style0 from "./MessageForm.vue?vue&type=style&index=0&id=21ff6fc8&prod&lang=css"
import style1 from "./MessageForm.vue?vue&type=style&index=1&id=21ff6fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff6fc8",
  null
  
)

export default component.exports